import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:ty.landers@cuw.edu">ty.landers@cuw.edu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/cuw/siteComponents/helpContent.js